import { Component } from '@angular/core';
import { RoutingService } from '@rci/routing-service';
import { BreadcrumbsService } from './breadcrumbs.service';

@Component({
  selector: 'fss-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  constructor(
    private readonly breadcrumbsService: BreadcrumbsService,
    private readonly routingService: RoutingService,
  ) {}

  get breadcrumbs$() {
    return this.breadcrumbsService.breadcrumbs$;
  }

  handleClick(url) {
    this.routingService.navigate(url);
  }
}
